import React from "react";
import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { SITE } from "../../site.config";
import { SUBURBS, INDEXABLE_SUBURB_SLUGS, SUBURB_PATH } from "../../suburbs";

export default function ServiceAreas() {
  return (
    <section
      id="areas"
      data-testid="areas-section"
      className="relative py-24 md:py-32 bg-[#0A0A0A] border-y border-white/10 overflow-hidden"
    >
      <div className="absolute inset-0 grain" aria-hidden="true" />
      <div
        className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full opacity-20 blur-3xl"
        style={{ background: "radial-gradient(circle, #5EE6E6, transparent 70%)" }}
        aria-hidden="true"
      />

      <div className="relative z-10 max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-4">
              <span className="h-px w-10 bg-cyan-pz" />
              <span className="bebas text-cyan-pz tracking-[0.3em] text-sm">
                WHERE OUR CUSTOMERS COME FROM
              </span>
            </div>
            <h2 className="bebas text-white text-5xl md:text-7xl leading-[0.9] mb-6">
              ONE WORKSHOP. <br />
              <span className="text-cyan-pz">THE WHOLE COAST DRIVES IN.</span>
            </h2>
            <p className="text-white/70 barlow text-base md:text-lg leading-relaxed mb-6">
              Workshop based at <strong className="text-white">Kunda Park</strong>,
              with customers driving in from every suburb on the Sunshine Coast — from Caloundra in
              the south to Noosa in the north, and everywhere in between.
              Most of the Coast is within 30 minutes' drive of the workshop — drop your vehicle in and we'll get it sorted.
            </p>
            <div className="inline-flex items-center gap-3 border border-cyan-pz/40 bg-cyan-pz/5 px-5 py-3 clip-tag">
              <MapPin className="w-5 h-5 text-cyan-pz" />
              <span className="bebas text-white tracking-widest">
                {SITE.business.address.full}
              </span>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-px bg-white/10 border border-white/10">
              {SUBURBS.map((s, i) => {
                const isIndexable = INDEXABLE_SUBURB_SLUGS.includes(s.slug);
                const inner = (
                  <>
                    <span className="bebas text-cyan-pz/60 text-xs tracking-widest w-6">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="bebas text-white tracking-wider text-base group-hover:text-cyan-pz transition-colors">
                      {s.name}
                    </span>
                    {SITE.driveTimes[s.name] && (
                      <span
                        data-testid={`drive-time-${s.slug}`}
                        className="ml-auto bebas text-cyan-pz/70 text-xs tracking-widest whitespace-nowrap"
                      >
                        {SITE.driveTimes[s.name]}
                      </span>
                    )}
                  </>
                );
                if (isIndexable) {
                  return (
                    <Link
                      key={s.slug}
                      to={SUBURB_PATH(s.slug)}
                      data-testid={`area-${s.slug}`}
                      className="bg-black px-5 py-4 flex items-center gap-3 hover:bg-cyan-pz/10 transition-colors group"
                    >
                      {inner}
                    </Link>
                  );
                }
                return (
                  <div
                    key={s.slug}
                    data-testid={`area-${s.slug}`}
                    className="bg-black px-5 py-4 flex items-center gap-3"
                  >
                    {inner}
                  </div>
                );
              })}
            </div>
            <p className="mt-4 text-white/40 barlow text-xs">
              Drive times are approximate, off-peak, to 2a/3 Hitech Dr, Kunda Park. Don't see your suburb? Doesn't matter — you're welcome at the
              workshop. Give us a call.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
